import config from 'config';
import { pickBy } from 'lodash';
import { createSelector } from 'reselect';
import {
  exIdSelector,
  signedInSelector,
} from 'shared/app/bundles/user/state/selectors';
import { localeTagSelector } from 'shared/app/state/selectors/locales';
import readCookie from 'shared/app/utils/read-cookie';

const { cookieName, dataFileTimeout, environment } = config.get(
  'universal.optimizely'
);

export const optimizelyUserId = readCookie(cookieName);

export { dataFileTimeout };

export const optimizelyUserAttributesSelector = createSelector(
  [exIdSelector, localeTagSelector, signedInSelector],
  (exId, locale, isSignedIn) => {
    return pickBy({
      environment,
      exId,
      locale,
      'is_user_authenticated': isSignedIn,
      'ux_exp_id': optimizelyUserId,
    });
  }
);
